/* PULSOO — interactions (sans dépendance) */
(function () {
  'use strict';
  var MONEY = null;
  var fmt = function (cents) {
    cents = Math.round(cents);
    var a = (cents / 100).toFixed(2), parts = a.split('.');
    var thou = function (n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    if (MONEY) {
      var f = MONEY.replace(/&nbsp;/g, '\u00a0').replace(/&euro;/g, '€');
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount') return thou(parts[0], ',') + '.' + parts[1];
        if (k === 'amount_no_decimals') return thou(String(Math.round(cents / 100)), ',');
        if (k === 'amount_no_decimals_with_comma_separator') return thou(String(Math.round(cents / 100)), '.');
        if (k === 'amount_with_space_separator') return thou(parts[0], ' ') + ',' + parts[1];
        if (k === 'amount_with_apostrophe_separator') return thou(parts[0], "'") + '.' + parts[1];
        return thou(parts[0], '.') + ',' + parts[1];
      });
    }
    return thou(parts[0], ' ') + ',' + parts[1] + ' €';
  };

  /* ---------- Apparition au scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.pz-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Vitrine des coloris ---------- */
  function initColors(root) {
    (root || document).querySelectorAll('[data-pz-colors]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var imgs = box.querySelectorAll('[data-pz-color-img]');
      var name = box.querySelector('[data-pz-color-name]');
      var cta = box.querySelector('[data-pz-color-cta]');
      box.querySelectorAll('[data-pz-color]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          var i = sw.getAttribute('data-pz-color');
          box.querySelectorAll('[data-pz-color]').forEach(function (s) { s.classList.toggle('is-active', s === sw); s.setAttribute('aria-pressed', s === sw); });
          imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-pz-color-img') === i); });
          if (name) name.textContent = sw.getAttribute('data-name');
          if (cta && sw.getAttribute('data-url')) cta.setAttribute('href', sw.getAttribute('data-url'));
        });
      });
    });
  }

  /* ---------- Page produit ---------- */
  function initPDP(root) {
    (root || document).querySelectorAll('[data-pz-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return; pdp.dataset.ready = '1';
      var dataEl = pdp.querySelector('[data-pz-variants]');
      if (!dataEl) return;
      var data = JSON.parse(dataEl.textContent);
      var variants = data.variants, colors = data.colors || [];
      if (data.moneyFormat) MONEY = data.moneyFormat;
      var track = pdp.querySelector('[data-pz-track]');
      var slides = Array.prototype.slice.call(pdp.querySelectorAll('.pz-slide'));
      var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-pz-thumb]'));
      var dotsBox = pdp.querySelector('[data-pz-dots]');
      var countEl = pdp.querySelector('[data-pz-count]');
      var idInput = pdp.querySelector('input[name="id"]');
      var atc = pdp.querySelector('.pz-atc');
      var atcLabel = atc ? atc.querySelector('span') : null;
      var priceNow = pdp.querySelector('[data-pz-price]');
      var priceWas = pdp.querySelector('[data-pz-was]');
      var colorLabel = pdp.querySelector('[data-pz-color-label]');
      var qtyInput = pdp.querySelector('input[name="quantity"]');
      var sticky = document.querySelector('[data-pz-sticky="' + pdp.dataset.section + '"]');
      var current = variants.find(function (v) { return String(v.id) === String(idInput.value); }) || variants[0];
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      function colorOf(alt) {
        alt = (alt || '').toLowerCase();
        for (var i = 0; i < colors.length; i++) { if (alt.indexOf('coloris ' + colors[i].toLowerCase()) > -1) return colors[i]; }
        return null;
      }
      slides.forEach(function (s) { s._color = colorOf(s.getAttribute('data-alt')); });
      thumbs.forEach(function (t, i) { t._color = slides[i] ? slides[i]._color : null; });

      function visible() { return slides.filter(function (s) { return !s.classList.contains('is-hidden'); }); }
      function activeIndex() {
        var vis = visible(); if (!track || !vis.length) return 0;
        var w = track.clientWidth || 1; return Math.max(0, Math.min(vis.length - 1, Math.round(track.scrollLeft / w)));
      }
      function renderDots() {
        var vis = visible(), a = activeIndex();
        if (dotsBox) {
          dotsBox.innerHTML = '';
          vis.forEach(function (s, i) {
            var b = document.createElement('button'); b.type = 'button';
            b.setAttribute('aria-label', 'Image ' + (i + 1) + ' sur ' + vis.length);
            if (i === a) b.className = 'is-active';
            b.addEventListener('click', function () { go(i); });
            dotsBox.appendChild(b);
          });
        }
        if (countEl) countEl.textContent = (a + 1) + ' / ' + vis.length;
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', slides[i] === vis[a]); });
      }
      function go(i, instant) {
        var vis = visible(); if (!track || !vis.length) return;
        i = (i + vis.length) % vis.length;
        track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
        setTimeout(renderDots, instant ? 0 : 350);
      }
      function filterGallery(color) {
        slides.forEach(function (s) { s.classList.toggle('is-hidden', !!(s._color && s._color !== color)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-hidden', !!(t._color && t._color !== color)); });
        // place la première image du coloris en tête de la galerie visible
        var vis = visible(); var first = vis.findIndex(function (s) { return s._color === color; });
        if (track) track.scrollLeft = 0;
        go(first > -1 ? first : 0, true);
      }
      if (track) {
        var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(renderDots, 60); }, { passive: true });
        window.addEventListener('resize', function () { go(activeIndex(), true); });
      }
      var prev = pdp.querySelector('[data-pz-prev]'), next = pdp.querySelector('[data-pz-next]');
      if (prev) prev.addEventListener('click', function () { go(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { go(activeIndex() + 1); });
      thumbs.forEach(function (tb, i) {
        tb.addEventListener('click', function () { var idx = visible().indexOf(slides[i]); if (idx > -1) go(idx); });
      });

      function updatePrice() {
        var unit = current.price, total = unit * qty;
        var discount = (qty >= 2 && data.duoPercent) ? Math.round(total * data.duoPercent / 100) : 0;
        var label;
        if (!current.available) label = data.soldOut;
        else label = data.addLabel + ' · ' + fmt(total - discount);
        if (atcLabel) atcLabel.textContent = label;
        if (atc) atc.disabled = !current.available;
        if (priceNow) priceNow.textContent = fmt(unit);
        if (priceWas) {
          if (current.compare && current.compare > unit) { priceWas.textContent = fmt(current.compare); priceWas.hidden = false; }
          else priceWas.hidden = true;
        }
        if (sticky) {
          var sb = sticky.querySelector('[data-pz-sticky-price]'); if (sb) sb.textContent = fmt(total - discount);
          var sn = sticky.querySelector('[data-pz-sticky-name]'); if (sn) sn.textContent = current.title;
          var sbt = sticky.querySelector('.pz-btn'); if (sbt) sbt.disabled = !current.available;
          var si = sticky.querySelector('img'); if (si && current.image) { si.src = current.image; }
        }
      }

      function setVariant(v, push) {
        current = v; idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (colorLabel) colorLabel.textContent = v.option1;
        pdp.querySelectorAll('.pz-swatch').forEach(function (s) {
          var on = s.getAttribute('data-value') === v.option1;
          s.classList.toggle('is-active', on);
          var inp = s.querySelector('input'); if (inp) inp.checked = on;
        });
        if (push) { var act = pdp.querySelector('.pz-vtile.is-active'); if (act && act.parentElement) { var row = act.parentElement; row.scrollTo({ left: act.offsetLeft - row.clientWidth / 2 + act.clientWidth / 2, behavior: 'smooth' }); } }
        filterGallery(v.option1);
        updatePrice();
        if (push && window.history && history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
      }

      pdp.querySelectorAll('.pz-swatch input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var v = variants.find(function (x) { return x.option1 === inp.value; });
          if (v) setVariant(v, true);
        });
      });

      /* Offre quantité (1 ou 2 bracelets) */
      pdp.querySelectorAll('[data-pz-offer]').forEach(function (o) {
        var inp = o.querySelector('input');
        inp.addEventListener('change', function () {
          pdp.querySelectorAll('[data-pz-offer]').forEach(function (x) { x.classList.toggle('is-active', x === o); });
          qty = parseInt(inp.value, 10) || 1; if (qtyInput) qtyInput.value = qty; updatePrice();
        });
      });

      /* Barre d'achat fixe */
      if (sticky && atc && 'IntersectionObserver' in window) {
        var footer = document.querySelector('.footer');
        var atcOut = false, footIn = false;
        var refresh = function () { var show = atcOut && !footIn; sticky.classList.toggle('is-visible', show); document.body.classList.toggle('pz-has-sticky', show); };
        new IntersectionObserver(function (e) { atcOut = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; refresh(); }).observe(atc);
        if (footer) new IntersectionObserver(function (e) { footIn = e[0].isIntersecting; refresh(); }).observe(footer);
        var sbtn = sticky.querySelector('.pz-btn');
        if (sbtn) sbtn.addEventListener('click', function () { atc.click(); });
      }

      setVariant(current, false);
    });
  }

  function initAll(root) { initReveal(root); initColors(root); initPDP(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  // Dans l'éditeur, on affiche tout de suite les éléments animés
  if (window.Shopify && Shopify.designMode) document.documentElement.classList.add('pz-design');
})();
